import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DownloadState {
  downloadingStates: Record<string, boolean>;
  persistentNotifications: Record<string, string>;
}

const initialState: DownloadState = {
  downloadingStates: {},
  persistentNotifications: {},
};

const downloadSlice = createSlice({
  name: "downloads",
  initialState,
  reducers: {
    setDownloadState: (
      state,
      action: PayloadAction<{ id: string; isDownloading: boolean }>,
    ) => {
      const { id, isDownloading } = action.payload;
      state.downloadingStates[id] = isDownloading;
    },

    clearDownload: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      delete state.downloadingStates[id];
      delete state.persistentNotifications[id];
    },
  },
});

export const { setDownloadState, clearDownload } = downloadSlice.actions;

export default downloadSlice.reducer;
